import type { EnumUnion } from '@dresscode-frontend/utility-types';

/**
 * 契約一覧の共通ソート可能カラム（全契約タイプ共通）
 */
export const ContractOrderBy = {
  CONTRACT_NO: 'CONTRACT_NO',
  CONTRACT_TITLE: 'CONTRACT_TITLE',
  CONTRACT_STATUS: 'CONTRACT_STATUS',
  CONTRACT_START_DATE: 'CONTRACT_START_DATE',
  CONTRACT_END_DATE: 'CONTRACT_END_DATE',
} as const satisfies Record<string, string>;

export type ContractOrderBy = EnumUnion<typeof ContractOrderBy>;

/**
 * サブスクリプション契約固有のソート可能カラム
 */
export const SubscriptionContractOrderBy = {
  ...ContractOrderBy,
  SOFTWARE_LIBRARY_NAME: 'SOFTWARE_LIBRARY_NAME',
} as const satisfies Record<string, string>;

export type SubscriptionContractOrderBy = EnumUnion<
  typeof SubscriptionContractOrderBy
>;

/**
 * 契約カテゴリの定義
 */
export const ContractType = {
  EMPLOYMENT: 'EMPLOYMENT', // 雇用契約
  DELEGATION: 'DELEGATION', // 委任契約
  SERVICE: 'SERVICE', // 業務委託
  LEASE: 'LEASE', // リース
  SUBSCRIPTION: 'SUBSCRIPTION', // サブスクリプション契約
  PURCHASE: 'PURCHASE', // 購買契約
  SAAS_SOFTWARE: 'SAAS_SOFTWARE', // SaaS・ソフトウェア
  OFFICE_RENTAL: 'OFFICE_RENTAL', // オフィス賃貸
  OTHER: 'OTHER', // その他
  ALL: 'ALL',
} as const;

export type ContractType = (typeof ContractType)[keyof typeof ContractType];

/**
 * テーブルカラムの定義
 */
export const ContractTableColumns = {
  contractNo: 'contractNo',
  contractTitle: 'contractTitle',
  contractStatus: 'contractStatus',
  softwareLibrary: 'softwareLibrary',
  contractStartDate: 'contractStartDate',
  contractEndDate: 'contractEndDate',
} as const;

export type ContractTableColumns =
  (typeof ContractTableColumns)[keyof typeof ContractTableColumns];
